import { apiClient, type Paginated } from '@/core/api';
import type {
  NotificationDto,
  NotificationListParams,
  NotificationPreferenceDto,
  NotificationPreferenceUpdateInput,
  UnreadCountDto,
} from './types';

/** `GET /api/notifications/` — the caller's own inbox. */
export async function getNotifications(
  params: NotificationListParams = {}
): Promise<Paginated<NotificationDto>> {
  const { data } = await apiClient.get<Paginated<NotificationDto>>('/notifications/', { params });
  return data;
}

/** `GET /api/notifications/unread-count/` — the badge number. */
export async function getUnreadCount(): Promise<UnreadCountDto> {
  const { data } = await apiClient.get<UnreadCountDto>('/notifications/unread-count/');
  return data;
}

/** `POST /api/notifications/{public_id}/read/` */
export async function markRead(publicId: string): Promise<NotificationDto> {
  const { data } = await apiClient.post<NotificationDto>(`/notifications/${publicId}/read/`);
  return data;
}

/** `POST /api/notifications/read-all/` */
export async function markAllRead(): Promise<{ updated: number }> {
  const { data } = await apiClient.post<{ updated: number }>('/notifications/read-all/');
  return data;
}

/** `GET /api/notification-preferences/` — the caller's own switches. */
export async function getPreferences(): Promise<NotificationPreferenceDto> {
  const { data } = await apiClient.get<NotificationPreferenceDto>('/notification-preferences/');
  return data;
}

/** `PATCH /api/notification-preferences/` */
export async function updatePreferences(
  input: NotificationPreferenceUpdateInput
): Promise<NotificationPreferenceDto> {
  const { data } = await apiClient.patch<NotificationPreferenceDto>(
    '/notification-preferences/',
    input
  );
  return data;
}
